import { array as codecArray } from 'purify-ts/Codec';
import { makeResponses } from '../response_factory';
import { utils as coreUtils, paginated, requestParams } from '@codegrade/api-core';
import { Notification, NotificationSummary, PatchAllNotificationData, PatchNotificationData, } from '@codegrade/api-models';
import { parsers } from '@codegrade/utils';
const makeResult = coreUtils.makeResult;
// eslint-disable-next-line @typescript-eslint/no-unused-vars,unused-imports/no-unused-vars
const parseJsonResponse = /* #__PURE__ */ parsers.parseJsonResponse;
export function notification(config) {
    const getAllResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ paginated.makeResult(
        /* #__PURE__ */ parseJsonResponse(/* #__PURE__ */ codecArray(Notification))),
    });
    const patchAllResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(
        /* #__PURE__ */ parseJsonResponse(/* #__PURE__ */ codecArray(Notification))),
    });
    const getSummaryResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(/* #__PURE__ */ parseJsonResponse(NotificationSummary)),
    });
    const patchResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(/* #__PURE__ */ parseJsonResponse(Notification)),
    });
    return Object.freeze({
        /**
         * Get all notifications for the current user.
         *
         * @param arg The arguments to the function.
         * @param arg.read If passed only return notifications that have this read status.
         * @param arg.pageSize The size of a single page, maximum is 50.
         * @param arg.nextToken The next token, to retrieve a next page.
         * @returns A list of notifications.
         */
        getAll: async ({ read = undefined, pageSize = undefined, nextToken = undefined, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/notifications/`, getAllResponse.v, undefined, {
                read,
                'page-size': pageSize,
                'next-token': nextToken,
            });
            return result;
        },
        /**
         * Update the read status of multiple notifications.
         *
         * @param arg The arguments to the function.
         * @param arg.requestBody The body of the request.
         * @returns The updated notifications in the same order as given in the body.
         */
        patchAll: async ({ requestBody, }) => {
            const result = await requestParams(config, 'PATCH', `/api/v1/notifications/`, patchAllResponse.v, JSON.stringify(PatchAllNotificationData.encode(requestBody)));
            return result;
        },
        /**
         * Get a summary of the user's notifications.
         *
         * Provides a capped count of unread notifications for performance.
         *
         * @returns A summary object with unread counts.
         */
        getSummary: async () => {
            const result = await requestParams(config, 'GET', `/api/v1/notifications/summary`, getSummaryResponse.v, undefined);
            return result;
        },
        /**
         * Update the read status for the given notification.
         *
         * @param arg The arguments to the function.
         * @param arg.notificationId The id of the notification to update.
         * @param arg.requestBody The body of the request.
         * @returns The updated notification.
         */
        patch: async ({ notificationId, requestBody, }) => {
            const result = await requestParams(config, 'PATCH', `/api/v1/notifications/${notificationId}`, patchResponse.v, JSON.stringify(PatchNotificationData.encode(requestBody)));
            return result;
        },
    });
}
